import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { LoginnavbarComponent } from './login-navbar/login-navbar.component';
// import { SidebarComponent } from './sidebar/sidebar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AdminNavbarComponent } from './admin-navbar/admin-navbar.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatRippleModule,
        MatFormFieldModule,
        MatTooltipModule,
        MatSelectModule,
        NgSelectModule,
        MatCheckboxModule,
        BsDatepickerModule.forRoot(),
    ],
    declarations: [
        FooterComponent,
        NavbarComponent,
        LoginnavbarComponent,
        AdminNavbarComponent,
    ],
    exports: [
        FooterComponent,
        NavbarComponent,
        LoginnavbarComponent,
        AdminNavbarComponent,
        //SidebarComponent
    ], providers: [
        DatePipe,
    ]
})
export class ComponentsModule { }
